import React, { useState } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import { Button, Card, CardBody } from "reactstrap"

//import EcommerceOrdersModal from "../Ecommerce/EcommerceOrders/EcommerceOrdersModal";
//import { latestTransaction } from "./dashboard"

import TableContainer from "../../components/Common/TableContainer"
import { Link } from "react-router-dom"

const LatestTranaction = ({ columns, latestTransaction }) => {
  //
  const [modal1, setModal1] = useState(false)

  const toggleViewModal = () => setModal1(!modal1)

  return (
    <React.Fragment>
      {/* <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} /> */}
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">Últimos Recibos Pago</div>

          <TableContainer
            columns={columns}
            data={latestTransaction}
            isGlobalFilter={false}
            tableClass="align-middle table-nowrap mb-0"
            theadClass="table-light"
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

LatestTranaction.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
}

export default withRouter(LatestTranaction)
